import React, { useState } from "react";
import { PermissionCheck } from "src/helpers/PermissionCheck";
import RequestsList from "./RequestsList";

const OverviewTransfersKindergarten: React.FC = () => {
  const [view, setView] = useState("pending");

  return (
    <>
      {(PermissionCheck("transfer-list-all") || PermissionCheck("transfer-list-to-verify")) && (
        <>{view === "pending" && <RequestsList />}</>
      )}
    </>
  );
};

export default OverviewTransfersKindergarten;
